import QRAuth from './qr-auth'

export default QRAuth
